import React, { useState, useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import {  toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
// import loginImg from '../Img/login_new.jpg'

const ResetPassword = () => {
    const [step, setStep] = useState(1); 
    const [email, setEmail] = useState('');
    const [otp, setOtp] = useState(Array(6).fill(''));
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const otpRefs = useRef([]);
    const navigate = useNavigate();
    const [load, setLoad] = useState(false);
    const [load1, setLoad1] = useState(false);
    const [load2, setLoad2] = useState(false);
    const [emailError, setEmailError] = useState('');

    const handleEmailSubmit = async (e) => {
        e.preventDefault();
        setLoad(true);
        setEmailError(''); 

        if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
            setEmailError('Please enter a valid email address.');
            setLoad(false);
            return;
        }

        try {
            const response = await fetch(`https://backend.impactjournal.co.in/auth/send-otp`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({ email })
            });

            const res = await response.json();

            if (!response.ok) {
                setEmailError(res.message || "Failed to send OTP.");
                setLoad(false);
                return;
            }

            toast.success("OTP sent to your email", {
                position: "top-center",
                autoClose: 3000
            });
            setStep(2);
        } catch (error) {
            setEmailError("Server error. Please try again.");
        } finally {
            setLoad(false);
        }
    };

    const handleOtpChange = (e, index) => {
        const value = e.target.value;
        if (/^\d*$/.test(value) && value.length <= 1) {
            const newOtp = [...otp];
            newOtp[index] = value;
            setOtp(newOtp);

            if (value && index < otp.length - 1) {
                otpRefs.current[index + 1].focus();
            }
        }
    };


    const handleVerifyOtp = async () => {
        const otpString = otp.join('');
        if (otpString.length === 6) {
            setLoad1(true);
            try {
                const response = await fetch(`https://backend.impactjournal.co.in/auth/verify-otp`, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify({ email, otp: otpString })
                });

                const data = await response.json();  

                if (response.ok) {
                    toast.success('OTP verified successfully!', {
                        position: "top-center",
                        autoClose: 3000
                    });
                    setLoad1(false)
                    setStep(3);
                } else {
                    toast.warning(data.message || "Something went wrong", {  
                        position: "top-center",
                        autoClose: 3000
                    });
                    setLoad1(false)
                }
            } catch (error) {
                toast.error("Network error. Please try again later.", {   
                    position: "top-center",
                    autoClose: 3000
                });
                setLoad1(false)
            }
        } else {
            toast.error('Invalid OTP. Please try again.');
            setLoad1(false)
        }
    };


    const handlePasswordReset = async (e) => {
        e.preventDefault();

        const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@#$%^&+=!]).{8,}$/;

        if (!passwordRegex.test(password)) {
            toast.error('Password must be at least 8 characters long and include uppercase, lowercase, number, and special character.');
            return;
        }

        if (password !== confirmPassword) {
            toast.error('Passwords do not match.');
            return;
        }
        setLoad2(true)
        try {
            const response = await fetch(`https://backend.impactjournal.co.in/auth/reset-password`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    email,
                    newPassword: password
                })
            })
            const res = await response.json();
            if (response.ok) {
                toast.success('Password reset successfully!', {
                    position: "top-center",
                    autoClose: 3000
                });

                setTimeout(() => {
                    navigate("/login");
                }, 1500); 
            }


            setLoad2(false)
        } catch (error) {
            toast.error(error, {
                position: "top-center",
                autoClose: 3000
            })
            setLoad2(false)
        }
    };

    return (
        <>
            
            <div className="login-bg">
                <div className="login-img">
                    {/* <img src={loginImg} alt="" /> */}
                </div>
                <div className="login-box reset-box">
                    <h2>Reset Password</h2>
                    {step === 1 && (
                        <>
                            <form onSubmit={handleEmailSubmit}>
                                <input
                                    type="email"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    placeholder="Email address"
                                    required
                                />
                                {emailError && <p style={{ color: "red", marginTop: "5px", fontSize: "0.9rem" }}>{emailError}</p>}

                                {
                                    load ? <button type="button">Loading...</button> :
                                        <button type="submit">Send OTP</button>
                                }

                                <p className="register">
                                    Already register? <Link to='/login'>Login now</Link>
                                </p>
                            </form>
                        </>
                    )}
                    {step === 2 && (
                        <>
                            <p>Enter the 6-digit OTP sent to your email.</p>
                            <div className="otp-inputs">
                                {otp.map((digit, index) => (
                                    <input
                                        key={index}
                                        type="text"
                                        maxLength="1"
                                        value={digit}
                                        onChange={(e) => handleOtpChange(e, index)}
                                        ref={(el) => (otpRefs.current[index] = el)}
                                        className="otp-input"
                                        placeholder="-"
                                    />
                                ))}
                            </div>
                            {
                                load1 ? <button >Loading...</button> :
                                    <button onClick={handleVerifyOtp}>Verify OTP</button>
                            }

                            <p className="register">
                                Already register? <Link to='/login'>Login now</Link>
                            </p>
                        </>
                    )}
                    {step === 3 && (
                        <>
                            <p>Set a new password.</p>
                            <form onSubmit={handlePasswordReset}>
                                <input
                                    type="password"
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    placeholder="New Password"
                                    required
                                />
                                <input
                                    type="password"
                                    value={confirmPassword}
                                    onChange={(e) => setConfirmPassword(e.target.value)}
                                    placeholder="Confirm Password"
                                    required
                                />
                                {
                                    load2 ? <button type="button">Loading...</button> :
                                        <button type="submit">Reset Password</button>
                                }
                               

                                <p className="register">
                                    Already register? <Link to='/login'>Login now</Link>
                                </p>
                            </form>
                        </>
                    )}
                </div>
            </div>
        </>
    );
};

export default ResetPassword;
